import React from "react";
import { FROSTED_PANEL_STYLE } from "./constants";
import useLockBodyScroll from "../../hooks/useLockBodyScroll";

/**
 * Compact centered confirmation alert on the shared frosted surface.
 * variant="danger" → red icon + red action (destructive, e.g. remove).
 * variant="default" → amber caution icon + brand action (non-destructive).
 */
function ConfirmDialog({ title, message, onConfirm, onCancel, confirmText = "Confirm", cancelText = "Cancel", variant = "default" }) {
  useLockBodyScroll(true);
  const isDanger = variant === "danger";
  const iconWrap = isDanger ? "bg-rose-50 text-rose-600" : "bg-amber-50 text-amber-500";
  const confirmBtn = isDanger ? "bg-rose-600" : "bg-[var(--gmb-primary)]";

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/15 backdrop-blur-[3px]" onClick={onCancel} />
      <div className="rounded-lg w-full max-w-[360px] relative z-10 px-[22px] pt-[22px] pb-[18px] text-center" style={FROSTED_PANEL_STYLE}>
        <div className={`w-11 h-11 ${iconWrap} rounded-[11px] flex items-center justify-center mx-auto mb-[14px]`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[22px] h-[22px]">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <path d="M12 9v4M12 17h.01" />
          </svg>
        </div>
        <h3 className="text-[16px] font-semibold text-gray-900 mb-[5px]">{title}</h3>
        <p className="text-[13px] text-gray-500 leading-[1.5] mb-[18px] font-normal">{message}</p>
        <div className="flex items-center justify-center gap-[10px]">
          <button
            onClick={onCancel}
            className="px-[22px] py-[8px] rounded-lg font-medium text-[13px] text-slate-600 border border-[rgba(15,23,42,0.1)] hover:bg-slate-50 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-[22px] py-[8px] rounded-lg text-white font-medium text-[13px] shadow-sm hover:brightness-95 transition-all ${confirmBtn}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
